import { TFunction } from "react-i18next";
import { sortBy } from "lodash";
import { differenceInCalendarYears, getYear, parseISO } from "date-fns";
import { DateValuePair } from "@rentablo/api/apiv1";
import { HorizontalBarChartItem } from "../HorizontalBarChart/types";

export const buildChartData = (
  t: TFunction,
  positiveColor: string,
  negativeColor: string,
  historicQuotes?: DateValuePair[]
): HorizontalBarChartItem[] => {
  const sorted = sortBy(historicQuotes, ["date"]).reverse();
  return (
    sorted
      .filter(
        ({ date }) => date && getYear(parseISO(date)) !== getYear(new Date())
      )
      .map((quote) => {
        const year = differenceInCalendarYears(
          new Date(),
          parseISO(quote.date!)
        );
        const percentage = quote.value
          ? Math.round(quote.value * 10000) / 100
          : 0;
        return {
          title: t("fundamentals.year", { count: year }),
          value: percentage,
          valueFormatted: `${percentage}%`,
          color: percentage > 0 ? positiveColor : negativeColor,
        };
      }) || []
  );
};
